import * as React from 'react';

import type { NextPage } from 'next';

import { SignUpPage } from '@itp/talent/pages/auth/signUp';

const Page: NextPage = () => {
  return <SignUpPage />;
};

export default Page;
